import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadDeliveryRegions = async () => {
  try {
    const response = await Axios.get('delivery-regions');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};


const loadOne = async (name) => {
  try {
    const respnse = await Axios.get('delivery-regions/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadDeliveryRegion = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/delivery-regions');
        const responseData = await response.data;
        return {...responseData, deliveryRegion: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOne(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useDeliveryRegionAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('delivery-regions', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('delivery_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('delivery-regions/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('delivery_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  return { create, update };
};



export default useDeliveryRegionAPI;


